export default (() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-intl-tel-input').forEach((el) => {
      if (typeof window.intlTelInput === 'undefined') return
      let options = JSON.parse(el.dataset.intlTelInput || '{}') || {}
      let util_url =
        options.utils_url ||
        'https://cdn.jsdelivr.net/npm/intl-tel-input@27.0.10/dist/js/utils.js'
      options.loadUtils = () => import(util_url)
      if (options.phone_input_name || options.country_code_name) {
        let phone_input_name = options.phone_input_name
        let country_code_name = options.country_code_name
        options.hiddenInput = function () {
          return {
            phone: phone_input_name,
            country: country_code_name,
          }
        }
        delete options.phone_input_name
        delete options.country_code_name
      }
      delete options.utils_url
      if (options.debug) {
        delete options.debug
        console.log(options)
      }
      window.intlTelInput(el, options)
    })
  })
})()
